export { default } from './group-box-link';
